import React, { useState, useEffect } from "react";
import ParentAccess from "../../utils/parentaccess";
import { ButtonGroup, Button } from "shards-react";

const ParentAccessControl = function (props) {
    let [selectedParentAccessType, setSelectedParentAccessType] = useState({});

    useEffect(() => {
        if (props.initialType !== null) {
            setSelectedParentAccessType(props.initialType);
        }
    }, [props.initialType]);

    let switchDisplay = (event) => {
        const selectedId = parseInt(event.currentTarget.id, 10); // Convert string to integer
        console.log("Switching display to: ", selectedId);
        if (event !== undefined)
            setSelectedParentAccessType(selectedId);
        if (props.setParentAccessType !== null)
            props.setParentAccessType(selectedId);
    };

    return (
        <div>
            <ButtonGroup className="mb-3">
                <Button theme={selectedParentAccessType === ParentAccess.none || selectedParentAccessType == null ? "primary" : "white"} id={0} onClick={(e) => { switchDisplay(e) }}>None</Button>
                <Button theme={selectedParentAccessType === ParentAccess.open ? "primary" : "white"} id={1} onClick={(e) => { switchDisplay(e) }}>Open</Button>
                <Button theme={selectedParentAccessType === ParentAccess.withCode ? "primary" : "white"} id={2} onClick={(e) => { switchDisplay(e) }}>With Code</Button>
            </ButtonGroup>
        </div>
    );
}

export default ParentAccessControl;